import ProcurementDetail from '../components/ProcurementDetail'
import React, { useEffect, useRef, useState } from 'react'
import ReactDom from 'react-dom'
import Events from '../../../@utils/events'
import { Modal, Spin } from 'antd'
import service from '../../../@services'
import { procurementTypeEnum } from '../config'

export default function useGetProcurementDetail() {
  const MountDom = useRef(document.createElement('div'))
  const events = useRef(new Events())
  useEffect(() => {
    let _MountDom = MountDom.current
    document.body.appendChild(_MountDom)
    return () => {
      document.body.removeChild(_MountDom)
    }
  }, [])

  useEffect(() => {
    let _MountDom = MountDom.current
    ReactDom.render(<ProcurementModal events={events.current} />, _MountDom)
    return () => {
      ReactDom.unmountComponentAtNode(_MountDom)
    }
  }, [])

  const showDetail = (id, type, modalProps) => {
    events.current.emit('open', { id, type, modalProps })
  }
  const close = () => {
    events.current.emit('close')
  }
  return {
    showDetail,
    close
  }
}

const ProcurementModal = props => {
  const [$confirmLoading, set$confirmLoading] = useState(false)
  const [detail, setDetail] = useState({})
  const [$show, set$show] = useState(false)
  const [$modalProps, set$modalProps] = useState({})
  const [$onInit, set$onInit] = useState(true)

  useEffect(() => {
    const offOpen = props.events.on('open', _onOk => {
      open(_onOk)
    })
    const offClose = props.events.on('close', () => {
      close()
    })
    return () => {
      offOpen()
      offClose()
    }
  }, [props.events])
  const open = async ({ id, type, modalProps }) => {
    set$modalProps(modalProps)
    set$show(true)
    set$onInit(true)
    try {
      const _detail = await service[
        type == procurementTypeEnum[0] ? 'purchaseOrder' : 'purchaseReturn'
      ].getInfoById(id)
      set$onInit(false)
      _detail && setDetail(_detail)
    } catch (error) {
      console.log(error)
      set$onInit(false)
    }
  }
  const close = () => {
    set$confirmLoading(false)
    set$show(false)
  }
  return (
    <Modal
      visible={$show}
      width={1000}
      footer={null}
      onCancel={close}
      confirmLoading={$confirmLoading}
      onOk={close}
      {...$modalProps}>
      {$onInit ? (
        <Spin />
      ) : (
        React.createElement(ProcurementDetail, {
          procurementDetail: detail
        })
      )}
    </Modal>
  )
}
